import {
  getObj
} from '@/api/exam/course'
import {
  setStore,
  getStore
} from '@/utils/store'

const singup = {
   namespaced: true, // 必须开启命名空间
  state: {
    show: false
  },
  actions: {

  },
  getters: {
    show: (state) => {
      return state.show
    },


  },
  mutations: {
    SET_Tab: (state, flag) => {
      state.show = flag

    }
  }
}

export default singup
